<template>
  <div class="my-account">
    <div class="wrapper">
      <div class="header">
        <div class="headerCon">
          <div class="account acea-row row-top row-between">
            <!--<div class="assets">
              <div>累计充值(元)</div>
              <div class="money">{{ userInfo.recharge }}</div>
            </div>-->
              <router-link :to="'/user/Recharge'" class="recharge font-color-red" v-if="userInfo.admin_handle.recharge_status==1">充值</router-link>
              <router-link :to="'/'" class="recharge font-color-red"  v-if="userInfo.admin_handle.extract_status==1">提现</router-link>

              <router-link :to="'/user/transfer'" class="recharge font-color-red"  v-if="userInfo.admin_handle.transfer_status==1">转账</router-link>
              <router-link :to="'/user/change'" class="recharge font-color-red"  v-if="userInfo.admin_handle.change_status==1">转换</router-link>
          </div>
            <div class="cumulative acea-row row-top">
                <div class="item" v-for="(item, index) in moneyType" :key="index"  @click="toCommissionList(index)">
                    <div>{{item}}</div>
                    <div class="money">{{ userInfo[index]}}</div>
                </div>
            </div>
        </div>
      </div>
      <div class="nav acea-row row-middle">
        <router-link class="item" :to="'/user/bill/0'">
          <div class="pictrue"><img src="@assets/images/record1.png" /></div>
          <div>账单记录</div>
        </router-link>
        <router-link class="item" :to="'/user/recharge_list/0'" v-if="userInfo.admin_handle.recharge_log_status==1">
          <div class="pictrue"><img src="@assets/images/record2.png" /></div>
          <div>充值记录</div>
        </router-link>
        <router-link class="item" :to="'/user/cashrecord'" v-if="userInfo.admin_handle.extract_log_status==1">
          <div class="pictrue"><img src="@assets/images/record3.png" /></div>
          <div>提现记录</div>
        </router-link>
        <router-link class="item" :to="'/user/transfercord'" v-if="userInfo.admin_handle.transfer_log_status==1">
          <div class="pictrue"><img src="@assets/images/record4.png" /></div>
          <div>转账记录</div>
        </router-link>
        <router-link class="item" :to="'/user/changecord'" v-if="userInfo.admin_handle.change_log_status==1">
          <div class="pictrue"><img src="@assets/images/record4.png" /></div>
          <div>转换记录</div>
        </router-link>
        <!--<router-link class="item" :to="'/user/integral'">
          <div class="pictrue"><img src="@assets/images/record4.png" /></div>
          <div>积分中心</div>
        </router-link>-->
      </div>
      <!--<div class="advert acea-row row-between-wrapper">
        <router-link
          class="item acea-row row-between-wrapper"
          :to="'/user/sign'"
        >
          <div class="text">
            <div class="name">签到领积分</div>
            <div>赚积分抵现金</div>
          </div>
          <div class="pictrue"><img src="@assets/images/gift.png" /></div>
        </router-link>
        <router-link
          class="item on acea-row row-between-wrapper"
          :to="'/user/get_coupon'"
        >
          <div class="text">
            <div class="name">领取优惠券</div>
            <div>满减享优惠</div>
          </div>
          <div class="pictrue"><img src="@assets/images/money.png" /></div>
        </router-link>
      </div>-->
      <!--<div class="list">
        <div class="item acea-row row-between-wrapper">
          <div class="picTxt acea-row row-between-wrapper">
            <div class="iconfont icon-hebingxingzhuang"></div>
            <div class="text">
              <div class="line1">最新拼团活动</div>
              <div class="infor line1">最新的优惠商品上架拼团</div>
            </div>
          </div>
          <router-link
            class="bnt"
            :to="'/activity/group'"
            v-if="activity.is_pink"
            >立即参与</router-link
          >
          <div class="bnt end" v-else>已结束</div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="picTxt acea-row row-between-wrapper">
            <div class="iconfont icon-miaosha yellow"></div>
            <div class="text">
              <div class="line1">当前限时秒杀</div>
              <div class="infor line1">最新商品秒杀进行中</div>
            </div>
          </div>
          <router-link
            class="bnt"
            :to="'/activity/goods_seckill'"
            v-if="activity.is_seckill"
            >立即参与</router-link
          >
          <div class="bnt end" v-else>已结束</div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="picTxt acea-row row-between-wrapper">
            <div class="iconfont icon-kanjia1 green"></div>
            <div class="text">
              <div class="line1">砍价活动</div>
              <div class="infor line1">呼朋唤友来砍价</div>
            </div>
          </div>
          <router-link
            class="bnt"
            :to="'/activity/bargain'"
            v-if="activity.is_bargin"
            >立即参与</router-link
          >
          <div class="bnt end" v-else>已结束</div>
        </div>
      </div>-->
    </div>
    <Recommend></Recommend>
  </div>
</template>
<style>
  .my-account .wrapper .header .headerCon .account .recharge{
    font-size: 0.25rem;
    width: 1.2rem;
    height: 0.54rem;
    border-radius: 0.2rem;
    background-color: #fff9f8;
    text-align: center;
    line-height: 0.54rem;
    padding: 0px;
    color: #ec5d59 !important;
  }
</style>
<script>
import Recommend from "@components/Recommend";
import { getActivityStatus,getUser } from "../../api/user";

import { getHomeData, getShare, follow } from "@api/public";
import { openShareAll, wxShowLocation } from "@libs/wechat";

import { isWeixin } from "@utils/index";

export default {
  name: "UserAccount",
  components: {
    Recommend
  },
  props: {},
  data: function() {
    return {
        userInfo: {},
        moneyType:[],
      orderStatusSum: 0,
      recharge: 0,
      activity: {
        is_bargin: false,
        is_pink: false,
        is_seckill: false
      }
    };
  },
  mounted: function() {
    this.getIndex();
    this.getActivity();
      this.setOpenShare();
  },
  methods: {
      toCommissionList(type){
          this.$router.push({path:'/user/bill/'+type})
      },
    getIndex: function() {
      let that = this;
      getUser().then(
        res => {
          that.moneyType = res.data.moneyType;
          that.userInfo = res.data;
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    },
    getActivity: function() {
      let that = this;
      getActivityStatus().then(
        res => {
          that.activity.is_bargin = res.data.is_bargin;
          that.activity.is_pink = res.data.is_pink;
          that.activity.is_seckill = res.data.is_seckill;
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    },setOpenShare() {
          if (isWeixin()) {


                  getUser().then(res => {
                      var href = location.href;

                      href =
                          href.indexOf("?") === -1
                              ? href + "?spread=" + res.data.uid
                              : href + "&spread=" + res.data.uid;
                      var nickname = res.data.nickname;


                      getShare().then(res => {
                          var data = res.data.data;
                          var configAppMessage = {
                              desc: '['+nickname+'邀请] '+data.synopsis,
                              title: data.title,
                              link: href,
                              imgUrl: data.img
                          };
                          openShareAll(configAppMessage);
                      });
                  })



          }
      }
  }
};
</script>
